import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MerakisService } from '@app/features/merakis/shared/merakis.service';
import { MerakiAdmin } from '@app/shared/models/meraki/meraki-admin.model';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-meraki-admin-audit',
    templateUrl: './meraki-admin-audit.component.html',
    styleUrls: ['./meraki-admin-audit.component.css'],
    standalone: false
})
export class MerakiAdminAuditComponent implements OnInit, OnDestroy {
    @ViewChild('adminTable') adminTable: MatTable<MerakiAdmin>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    isLoading = false;
    merakiAdmins = [];
    displayedColumns = ['name', 'email', 'orgAccess'];
    dataSource = new MatTableDataSource<MerakiAdmin>(this.merakiAdmins);

    constructor(
        private mearkisService: MerakisService
    ) { }

    ngOnInit() {
        this.isLoading = true;
        Promise.resolve(
            this.getMerakiAdmins()
        ).then(() => {
            this.dataSource.paginator = this.paginator;
            this.adminTable.renderRows();
            this.isLoading = false;
        });
    }

    ngOnDestroy() { }

    getMerakiAdmins() {
        const promise = new Promise((resolve, reject) => {
            this.mearkisService.getMerakiAdmins().then(response => {
                response.toPromise().then(admins_from_response => {
                    try {
                        admins_from_response["message"].forEach(admin_json => {
                            let merakiAdmin: MerakiAdmin = admin_json;
                            this.merakiAdmins.push(merakiAdmin);
                        });
                    } catch (error) {
                        console.log("Meraki admins timed out!")
                    } finally {
                        resolve(true);
                    }
                });
            });
        });
        return promise;
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}